export const activities = [
    {
        name: 'Done something..', 
        time: '31/10/2019'
    },
    {
        name: 'Done something..', 
        time: '31/10/2019'
    },{
        name: 'Done something..', 
        time: '31/10/2019'
    },
];